import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@michelin/auth';
import { ApplicationComponent } from './application/application.component';
import { GroupComponent } from './application/group/group.component';
import { ApplicationsComponent } from './applications/applications.component';
import { AudtisComponent } from './audits/audits.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthGuardReturnBack } from './guards/auth.guard';
import { HomecvmComponent } from './homecvm/homecvm.component';
import { HomescriptComponent } from './homescript/homescript.component';
import { HometablesComponent } from './hometables/hometables.component';
import { HomexlsxComponent } from './homexlsx/homexlsx.component';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  {
    path: 'login',
    children: [{ path: '', component: AuthenticationComponent }]
  },
  {
    path: '',
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./home/home.module').then((m) => m.HomeModule), canActivate: [AuthGuardReturnBack] },
      {
        path: 'applications',
        children: [
          { path: '', component: ApplicationsComponent },
          { path: ':name', component: ApplicationComponent }
        ]
      },
      { path: 'contact', loadChildren: () => import('./contact/contact.module').then((m) => m.ContactModule) },
      {
        path: 'notifications',
        loadChildren: () => import('./notifications/notifications.module').then((m) => m.NotificationsModule)
      },
      { path: 'request', loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule) },
      {
        path: ':name',
        children: [
          { path: 'csv', component: HomecvmComponent },
          { path: 'xlsx', component: HomexlsxComponent },
          { path: 'script', component: HomescriptComponent },
          { path: 'repository', component: GroupComponent },
          { path: 'configuration', component: ApplicationComponent },
          { path: 'tables', component: HometablesComponent },
          { path: 'audits', component: AudtisComponent }
        ]
      }
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
